import { z } from 'zod';

export const relatedTagSchema = z.object({
  fields: z.object({ name: z.string() }),
});
